module.exports = __webpack_public_path__ + "static/media/ic_sos.5786c0a5.svg";